const {toString} = Object.prototype;

export default function isRegexp(value) {
	return toString.call(value) === '[object RegExp]';
}
